import { Skeleton } from '@levitas/ui';

/** Skeleton com a forma do que vai chegar — nunca uma tela em branco. */
export function CarregandoTela() {
  return (
    <div className="min-h-dvh bg-[var(--cor-fundo)] p-4 sm:p-8" aria-busy="true" aria-live="polite">
      <span className="sr-only">Carregando…</span>
      <div className="mx-auto flex max-w-5xl flex-col gap-4">
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-32 w-full" />
        <div className="grid gap-4 sm:grid-cols-2">
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      </div>
    </div>
  );
}
